// -- global var --
var glideGalleries = [];
var glideGalleriesTypeSlider = [];
var glideGalleryTypeFan;
var glideBannersMatrix;
var mountGlideGalleriesTypeSlider;
let root = document.documentElement;

ready(function(){
	
	const currentLang = document.documentElement.lang

	// ---------------------------
	// -- ACCESSIBILITY > FOCUS --
	// ---------------------------

	var glideDirActions = document.querySelectorAll('[data-glide-dir]');
	glideDirActions.forEach(glideDir => {
		glideDir.addEventListener('click', function(e) {
			var glide = this.closest('.glide');
			if (glide.classList.contains('type--bannersMatrix')) {
				var activeEl = glide.querySelector('[tabindex="-1"]');
				activeEl.focus();
			} 
			else if (glide.classList.contains('type--gallery')) {
				setTimeout(function(){
					var activeEl = glide.querySelector('.glide__slide--active a');
					activeEl.focus();
				}, 1000);
			}
			else {
				setTimeout(function(){
					var activeEl = glide.querySelector('.glide__slide--active');
					activeEl.focus();
				}, 1000);
			}
		});
	});


	// --------------------
	// -- BANNERS MATRIX --
	// --------------------

	const glideBannersMatrixEl = document.querySelector('.glide.type--bannersMatrix');
	if (glideBannersMatrixEl) {
		const baseline = glideBannersMatrixEl.querySelector('.baseline');	
		const playPauseBtn = glideBannersMatrixEl.querySelector('.playPauseBtn');	
		let glideBannersMatrixInterval;
		const glideBannersMatrixControls = {
			type: 'carousel',
			perView: 1,
			animationDuration: 0,
			autoplay: 6000,
			hoverpause: false,
		};
		glideBannersMatrix = new Glide(glideBannersMatrixEl, glideBannersMatrixControls);
		glideBannersMatrix.on(['build.after', 'run.after'], function(){
			const activeEl = glideBannersMatrix.selector.querySelector('.glide__slide--active');
			const dataHeading = activeEl.dataset.heading;
			const dataHeadingLangCode = activeEl.dataset.langcode;
			const dataColor = activeEl.dataset.color;
			const headingEl = document.getElementById('headingTxt');
			headingEl.innerHTML = dataHeading;
			headingEl.setAttribute('lang', dataHeadingLangCode);
			root.style.setProperty('--color', dataColor);
		});
	  baseline.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      const targetEl = document.querySelector(targetId);
	  	targetEl.setAttribute('tabindex', '-1');
	  	targetEl.focus();
	  });
	  playPauseBtn.addEventListener('click', function(e) {
			let state = playPauseBtn.getAttribute('data-state');
			if (state == 'running') {
				playPauseBtn.setAttribute('data-state', 'paused');
				glideBannersMatrix.pause();
			} else {
				playPauseBtn.setAttribute('data-state', 'running');
				glideBannersMatrix.play();
			}
	  });
		glideBannersMatrix.mount();
	}


	// -------------------------
	// -- GALLERY TYPE SLIDER --
	// -------------------------

	mountGlideGalleriesTypeSlider = function(){
		const glideGalleryTypeSlider = document.querySelectorAll('.glide.type--gallerySlider');
		if (glideGalleryTypeSlider.length) {
			const glideGalleryTypeSliderStyles = getComputedStyle(glideGalleryTypeSlider[0]);
			const glideGalleryTypeSliderPerView = parseFloat(glideGalleryTypeSliderStyles.getPropertyValue('--gallerySliderPerView'));
			const glideGalleryTypeSliderPerView1279 = parseFloat(glideGalleryTypeSliderStyles.getPropertyValue('--gallerySliderPerView1279'));
			const glideGalleryTypeSliderPerView1023 = parseFloat(glideGalleryTypeSliderStyles.getPropertyValue('--gallerySliderPerView1023'));
			const glideGalleryTypeSliderPerView767 = parseFloat(glideGalleryTypeSliderStyles.getPropertyValue('--gallerySliderPerView767'));
			const glideGalleryTypeSliderGap = parseFloat(glideGalleryTypeSliderStyles.getPropertyValue('--gallerySliderGap'));
			const glideGalleryTypeSliderFocusAt = glideGalleryTypeSliderStyles.getPropertyValue('--gallerySliderFocusAt');
			const glideGalleryTypeSliderControls = {
				type: 'carousel',
				perView: glideGalleryTypeSliderPerView,
				focusAt: glideGalleryTypeSliderFocusAt,
				gap: glideGalleryTypeSliderGap,
				animationDuration: 800,
				breakpoints: {
					1279: {
						perView: glideGalleryTypeSliderPerView1279,
					},
					1023: {
						perView: glideGalleryTypeSliderPerView1023,
					},
					767: {
						perView: glideGalleryTypeSliderPerView767,
						gap: 20,
					},
				}
			};

			glideGalleryTypeSlider.forEach(glide => {
				var slider = new Glide(glide, glideGalleryTypeSliderControls);
				const fancyboxEl = document.querySelector('.glide__slide [data-fancybox]');
				if (fancyboxEl) {				
					slider.on('mount.after', function() {
				  	Fancybox.bind('.glide__slide:not(.glide__slide--clone) [data-fancybox]', fancyboxOptions);
			  	  const clonedGallerySlides = document.querySelectorAll('.glide.type--gallerySlider .glide__slide--clone a');
						clonedGallerySlides.forEach(slideLink => {
							slideLink.addEventListener('click', function (e) {
							  e.preventDefault();
							  const index = this.parentElement.getAttribute('data-index');
			  	  		const initialSlideLink = document.querySelector('.glide.type--gallerySlider .glide__slide--'+index+':not(.glide__slide--clone) a');
			  	  		initialSlideLink.click();
							});
						});
					});
				}
				slider.mount();
				glideGalleriesTypeSlider.push(slider);
			});
		}
	}
	mountGlideGalleriesTypeSlider();


	// -----------------------
	// -- GALLERY TYPE FILM --
	// -----------------------

	const glideGallery = document.querySelectorAll('.glide.type--gallery');
	const glideGalleryControls = {
		type: 'carousel',
		perView: 2.4,
		gap: 0,
		animationDuration: 800,
		breakpoints: {
			1279: {
				perView: 1.8,
			},
			1023: {
				perView: 1.2,
			},
		}
	};
	if (glideGallery.length) {
		glideGallery.forEach(glide => {
			var slider = new Glide(glide, glideGalleryControls);
			slider.on('mount.after', function() {
			const fancyboxEl = document.querySelector('.glide__slide [data-fancybox]');
			if (fancyboxEl) {
		  	Fancybox.bind('.glide__slide:not(.glide__slide--clone) [data-fancybox]', fancyboxOptions);
	  	  const clonedGallerySlides = document.querySelectorAll('.glide.type--gallery .glide__slide--clone a');
				clonedGallerySlides.forEach(slideLink => {
					slideLink.addEventListener('click', function (e) {
					  e.preventDefault();
					  const index = this.parentElement.getAttribute('data-index');
	  	  		const initialSlideLink = document.querySelector('.glide.type--gallery .glide__slide--'+index+':not(.glide__slide--clone) a');
	  	  		initialSlideLink.click();
					});
				});
			}				
			});
			slider.mount();
			glideGalleries.push(slider);
		});
	}


	// ----------------------
	// -- GALLERY TYPE FAN --
	// ----------------------

	const glideGalleryTypeFanEl = document.querySelector('.glide.type--galleryFan');
	if (glideGalleryTypeFanEl) {
		const glideGalleryTypeFanControls = {
			type: 'carousel',
			perView: 3,
			focusAt: 'center',
			gap: 0,
			breakpoints: {
				1279: {
					perView: 2.2,
				},
				1023: {
					perView: 1.6,
				},
				767: {
					perView: 1.5,
				}
			}
		};	
		glideGalleryTypeFan = new Glide(glideGalleryTypeFanEl, glideGalleryTypeFanControls);
		
		glideGalleryTypeFan.on(['build.after', 'run.after'], function(){

			var slides = glideGalleryTypeFan.selector.querySelectorAll('.glide__slide');
			var activeEl = glideGalleryTypeFan.selector.querySelector('.glide__slide--active');
			var prev = activeEl.previousElementSibling;
			var next = activeEl.nextElementSibling;
			var prev2 = activeEl.previousElementSibling.previousElementSibling;
			var next2 = activeEl.nextElementSibling.nextElementSibling;
			var allPrev = prevAll(activeEl);
			var allNext = nextAll(activeEl);
			
			// -- reset class --
			slides.forEach((slide) => {
				slide.classList.remove('glide__slide--prev', 'glide__slide--next', 'glide__slide--prev2', 'glide__slide--next2', 'glide__slide--allPrev', 'glide__slide--allNext');
			});

			// -- update class --
			prev.classList.add('glide__slide--prev');
			next.classList.add('glide__slide--next');
			prev2.classList.add('glide__slide--prev2');
			next2.classList.add('glide__slide--next2');
			allPrev.forEach((prevEl) => {
				prevEl.classList.add('glide__slide--allPrev');
			});
			allNext.forEach((nextEl) => {
				nextEl.classList.add('glide__slide--allNext');
			});

		});

		glideGalleryTypeFan.on('mount.after', function(){
			var slides = glideGalleryTypeFan.selector.querySelectorAll('.glide__slide');
			slides.forEach((slide) => {
				slide.addEventListener('click', function (e) {
					var index = parseInt(this.getAttribute('data-index'));
					if (index === 0 || index > 0) {
						glideGalleryTypeFan.go('='+index);
					}
				});
			});
		});

		glideGalleryTypeFan.mount();

		// -- functions --
		function prevAll(element){
	  	const prevElements = []
	  	let prevElement = element;
		  while(prevElement.previousElementSibling){
		    prevElements.push(prevElement.previousElementSibling);
		    prevElement = prevElement.previousElementSibling;
		  }
	  	return prevElements
		}
		function nextAll(element){
	  	const nextElements = []
	  	let nextElement = element;
		  while(nextElement.nextElementSibling){
		    nextElements.push(nextElement.nextElementSibling);
		    nextElement = nextElement.nextElementSibling;
		  }
	  	return nextElements
		}
	}


});
